/**
 * Interface for the 'RegisterYourInterest' data
 */
export interface RegisterYourInterestState {
    status: RegisterYourInterestStatus;
    customerType?: CustomerType;
}

export enum RegisterYourInterestStatus {
    Uninitialized = "uninitialized",
    Loading = "loading",
    Loaded = "loaded",
    Error = "error",
}

export enum CustomerType {
    ReturningCustomer = "returningCustomer",
    SignupCustomer = "signupCustomer",
}

export const initialRegisterYourInterestState: RegisterYourInterestState = {
    status: RegisterYourInterestStatus.Uninitialized,
};
